import { gql, useMutation } from '@apollo/client';
import {
  cancelAppointment,
  cancelAppointmentVariables,
} from './__generated__/cancelAppointment';

export const CANCEL_APPOINTMENT = gql`
  mutation cancelAppointment($id: ID!) {
    cancelAppointment(id: $id)
  }
`;

export const useCancelAppointment = () =>
  useMutation<cancelAppointment, cancelAppointmentVariables>(
    CANCEL_APPOINTMENT,
    {
      // A cancelled appointment is no longer upcoming, so it is evicted from
      // the cache rather than left for the next refetch to remove. More than
      // one `UpcomingAppointments` list can be mounted at a time (the homepage
      // section and `/book`), and each keeps its own copy of the appointments
      // it was given, so without this a cancellation in one would leave the
      // other showing the appointment until its query happened to refetch.
      update: (cache, { data }, { variables }) => {
        if (!data?.cancelAppointment || !variables?.id) {
          return;
        }

        const cacheId = cache.identify({
          __typename: 'Appointment',
          id: variables.id,
        });

        if (!cacheId) {
          return;
        }

        // Apollo filters the now-dangling reference out of every cached
        // `upcomingAppointments` list on read, and notifies the queries
        // watching them.
        cache.evict({ id: cacheId });
        cache.gc();
      },
    },
  );
